module.exports = __webpack_public_path__ + "img/swapArrows.a923745c.svg";